/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminCreateProductMarketplace,
    AdminCreateProductMarketplaceFromJSON,
    AdminCreateProductMarketplaceFromJSONTyped,
    AdminCreateProductMarketplaceToJSON,
} from './AdminCreateProductMarketplace';
import {
    AdminProductStatus,
    AdminProductStatusFromJSON,
    AdminProductStatusFromJSONTyped,
    AdminProductStatusToJSON,
} from './AdminProductStatus';
import {
    ProductConsistency,
    ProductConsistencyFromJSON,
    ProductConsistencyFromJSONTyped,
    ProductConsistencyToJSON,
} from './ProductConsistency';

/**
 * 
 * @export
 * @interface AdminCreateProduct
 */
export interface AdminCreateProduct {
    /**
     * 
     * @type {number}
     * @memberof AdminCreateProduct
     */
    mSRP: number;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateProduct
     */
    asin?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminCreateProduct
     */
    categoryID: number;
    /**
     * 
     * @type {ProductConsistency}
     * @memberof AdminCreateProduct
     */
    consistency: ProductConsistency;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminCreateProduct
     */
    consistencyDetails?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateProduct
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof AdminCreateProduct
     */
    lowestResalePrice?: number;
    /**
     * 
     * @type {Array<AdminCreateProductMarketplace>}
     * @memberof AdminCreateProduct
     */
    marketplaces?: Array<AdminCreateProductMarketplace>;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateProduct
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof AdminCreateProduct
     */
    palletOrderID?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminCreateProduct
     */
    purchasePrice: number;
    /**
     * 
     * @type {AdminProductStatus}
     * @memberof AdminCreateProduct
     */
    status: AdminProductStatus;
}



export function AdminCreateProductFromJSON(json: any): AdminCreateProduct {
    return AdminCreateProductFromJSONTyped(json, false);
}

export function AdminCreateProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminCreateProduct {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mSRP': json['MSRP'],
        'asin': !exists(json, 'asin') ? undefined : json['asin'],
        'categoryID': json['categoryID'],
        'consistency': ProductConsistencyFromJSON(json['consistency']),
        'consistencyDetails': !exists(json, 'consistencyDetails') ? undefined : json['consistencyDetails'],
        'description': json['description'],
        'lowestResalePrice': !exists(json, 'lowestResalePrice') ? undefined : json['lowestResalePrice'],
        'marketplaces': !exists(json, 'marketplaces') ? undefined : ((json['marketplaces'] as Array<any>).map(AdminCreateProductMarketplaceFromJSON)),
        'name': json['name'],
        'palletOrderID': !exists(json, 'palletOrderID') ? undefined : json['palletOrderID'],
        'purchasePrice': json['purchasePrice'],
        'status': AdminProductStatusFromJSON(json['status']),
    };
}

export function AdminCreateProductToJSON(value?: AdminCreateProduct | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'MSRP': value.mSRP,
        'asin': value.asin,
        'categoryID': value.categoryID,
        'consistency': ProductConsistencyToJSON(value.consistency),
        'consistencyDetails': value.consistencyDetails,
        'description': value.description,
        'lowestResalePrice': value.lowestResalePrice,
        'marketplaces': !value.marketplaces ? undefined : ((value.marketplaces as Array<any>).map(AdminCreateProductMarketplaceToJSON)),
        'name': value.name,
        'palletOrderID': value.palletOrderID,
        'purchasePrice': value.purchasePrice,
        'status': AdminProductStatusToJSON(value.status),
    };
}

